import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Langs from "../../../../../app/lang/langs";

export default function FieldRow({ label, children, error }) {
  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          mb: 0.75,
          fontWeight: 600,
          fontSize: "0.8rem",
          color: error ? "error.main" : "text.secondary",
          letterSpacing: "0.03em",
          textTransform: "uppercase",
        }}
      >
        <Langs str={label} />
      </Typography>
      {children}
    </Box>
  );
}
